/* ============================================================
   MASKED YOUTH (Shopify theme) — UI interactions
   Header/footer/drawer are server-rendered in Liquid; this wires them.
   ============================================================ */

/* ---------- Toast ---------- */
let toastT;
function toast(msg){
  let t=document.getElementById("toast");
  if(!t){ t=document.createElement("div"); t.id="toast"; t.className="toast"; document.body.appendChild(t); }
  t.innerHTML = `<span>✓</span> ${msg}`;
  t.classList.add("show");
  clearTimeout(toastT); toastT=setTimeout(()=>t.classList.remove("show"),2600);
}

/* ---------- Page loader ---------- */
function initLoader(){
  const el=document.getElementById("pageload"); if(!el) return;
  const isHome = document.body.classList.contains("template-index");
  const hide=()=>setTimeout(()=>el.classList.add("hide"), isHome?900:450);
  if(document.readyState==="complete") hide(); else window.addEventListener("load",hide);
  setTimeout(()=>el.classList.add("hide"), isHome?2000:1500);
  window.addEventListener("pageshow",e=>{ if(e.persisted) el.classList.add("hide"); });
  // show loader before internal navigation
  document.addEventListener("click",e=>{
    if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
    if(e.target.closest("button")) return;
    const a=e.target.closest("a"); if(!a) return;
    const href=a.getAttribute("href"); if(!href) return;
    if(href.startsWith("#")||a.target==="_blank"||/^(https?:|mailto:|tel:)/i.test(href) && a.host!==location.host) return;
    if(a.host && a.host!==location.host) return;
    if(href.startsWith("#")) return;
    el.classList.remove("hide");
    setTimeout(()=>{ window.location.href=a.href; }, 380);
    e.preventDefault();
  });
}

/* ---------- Header: menu dropdown, cart, scroll ---------- */
function initHeader(){
  const trigger=document.getElementById("menuTrigger"), dd=document.getElementById("dropdown");
  trigger?.addEventListener("click",e=>{ e.stopPropagation(); const o=dd.classList.toggle("open"); trigger.classList.toggle("open",o); trigger.setAttribute("aria-expanded",o?"true":"false"); });
  document.addEventListener("click",e=>{ if(dd&&dd.classList.contains("open")&&!e.target.closest("#dropdown")&&!e.target.closest("#menuTrigger")){ dd.classList.remove("open"); trigger.classList.remove("open"); } });

  document.getElementById("cartBtn")?.addEventListener("click",()=>Cart.open());
  document.getElementById("cartClose")?.addEventListener("click",()=>Cart.close());
  document.getElementById("overlay")?.addEventListener("click",()=>Cart.close());
  document.getElementById("shipProtectChk")?.addEventListener("change",e=>Cart.setProtect(e.target.checked));
  document.addEventListener("keydown",e=>{ if(e.key==="Escape"){ Cart.close(); dd?.classList.remove("open"); } });

  let last=0;
  window.addEventListener("scroll",()=>{ const h=document.getElementById("header"); if(!h)return; const y=window.scrollY; if(y>last&&y>200)h.classList.add("header--hidden"); else h.classList.remove("header--hidden"); last=y; },{passive:true});
}

/* ---------- Add to cart / notify (event delegation) ---------- */
function initActions(){
  document.addEventListener("click",e=>{
    const add=e.target.closest("[data-add]");
    if(add){ e.preventDefault(); const id=add.getAttribute("data-add"); if(id) Cart.add(id,1); return; }
    const ntf=e.target.closest("[data-notify]");
    if(ntf){ e.preventDefault(); notifyMe(ntf.getAttribute("data-notify")); return; }
  });
}

/* ---------- Notify modal ---------- */
function notifyMe(name){
  const o=document.createElement("div"); o.className="overlay open"; o.style.zIndex=130;
  o.innerHTML=`<div style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);background:var(--paper);max-width:420px;width:92%;padding:36px;border-radius:4px">
    <button id="ntfClose" style="position:absolute;top:12px;right:16px;font-size:24px;line-height:1">×</button>
    <h3 style="font-family:'Helvetica Neue',Helvetica,Arial;font-weight:700;text-transform:uppercase;font-size:24px;margin-bottom:8px">Back-in-stock alert</h3>
    <p style="line-height:1.6;color:#333;margin-bottom:18px">${name||'This hat'} sold out. Drop your email and you'll be first to know the second it's back.</p>
    <form id="ntfForm" style="display:flex;flex-direction:column;gap:10px"><input type="email" required placeholder="Your email" style="border:1.5px solid var(--line);padding:15px 16px;border-radius:4px;font-size:14px"><button class="btn btn--block" type="submit">Notify Me</button></form>
    <div id="ntfOk" style="margin-top:12px;font-size:13px;color:var(--ok);font-weight:600;min-height:16px"></div></div>`;
  document.body.appendChild(o);
  const close=()=>o.remove();
  o.addEventListener("click",e=>{ if(e.target===o)close(); });
  o.querySelector("#ntfClose").addEventListener("click",close);
  o.querySelector("#ntfForm").addEventListener("submit",async e=>{
    e.preventDefault();
    const em=o.querySelector("input").value.trim(); const ok=o.querySelector("#ntfOk");
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)){ ok.style.color="#c0392b"; ok.textContent="Enter a valid email."; return; }
    const slug=(name||'product').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
    try{
      const fd=new FormData();
      fd.append("form_type","customer");
      fd.append("utf8","✓");
      fd.append("contact[email]", em);
      fd.append("contact[tags]", "restock,restock-"+slug);
      await fetch("/contact", {method:"POST", body:fd});
    }catch(err){}
    o.querySelector("#ntfForm").style.display="none"; ok.style.color=""; ok.textContent="You're on the list. We'll email you the second it drops.";
  });
}

/* ---------- Accordions ---------- */
function initAccordions(){
  document.querySelectorAll(".acc__q").forEach(q=>{ if(q.dataset.w)return; q.dataset.w="1"; q.addEventListener("click",()=>q.parentElement.classList.toggle("open")); });
}

/* ---------- Reveal on scroll ---------- */
function initReveal(){
  const io=new IntersectionObserver(es=>{ es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target);} }); },{threshold:.12,rootMargin:"0px 0px -8% 0px"});
  document.querySelectorAll(".reveal").forEach(el=>io.observe(el));
}

/* ---------- PDP: gallery + bundle ---------- */
function initPDP(){
  const thumbsEl=document.getElementById("thumbs"), mainImg=document.getElementById("mainImg");
  let gBtns=[], gSrcs=[], gIdx=0;
  function gShow(i){
    if(!gSrcs.length) return;
    gIdx=(i+gSrcs.length)%gSrcs.length;
    if(mainImg) mainImg.src=gSrcs[gIdx];
    gBtns.forEach((b,j)=>b.classList.toggle("active", j===gIdx));
    const a=gBtns[gIdx]; if(a&&a.scrollIntoView) a.scrollIntoView({inline:"center",block:"nearest",behavior:"smooth"});
  }
  function gBind(){
    gBtns=[].slice.call(thumbsEl?thumbsEl.querySelectorAll("button"):[]);
    gSrcs=gBtns.map(b=>b.dataset.src);
    gIdx=Math.max(0, gBtns.findIndex(b=>b.classList.contains("active")));
  }
  function setGallery(images){
    if(!thumbsEl||!mainImg||!images||!images.length) return;
    thumbsEl.innerHTML=images.map((src,i)=>`<button class="${i===0?'active':''}" type="button" data-src="${src}"><img src="${src}" alt="" loading="lazy"></button>`).join("");
    gBind(); gShow(0);
  }
  if(mainImg && thumbsEl){
    gBind();
    thumbsEl.addEventListener("click",e=>{ const b=e.target.closest("button"); if(!b)return; gShow(gBtns.indexOf(b)); });
    document.getElementById("galPrev")?.addEventListener("click",()=>gShow(gIdx-1));
    document.getElementById("galNext")?.addEventListener("click",()=>gShow(gIdx+1));
    const main=mainImg.parentElement; let x0=null;
    main.addEventListener("touchstart",e=>{ x0=e.touches[0].clientX; },{passive:true});
    main.addEventListener("touchend",e=>{ if(x0===null)return; const dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40) gShow(dx<0?gIdx+1:gIdx-1); x0=null; },{passive:true});
    document.addEventListener("keydown",e=>{ const t=e.target.tagName; if(t==="INPUT"||t==="TEXTAREA")return; if(e.key==="ArrowLeft")gShow(gIdx-1); else if(e.key==="ArrowRight")gShow(gIdx+1); });
  }

  // sticky add-to-cart: show when the main CTA scrolls out of view
  const sticky=document.getElementById("stickyAtc"), cta=document.querySelector(".pdp__cta");
  if(sticky&&cta){
    new IntersectionObserver(es=>{ es.forEach(e=>{ sticky.classList.toggle("show", !e.isIntersecting); }); },{rootMargin:"0px 0px -10% 0px"}).observe(cta);
  }
  document.getElementById("stickyAdd")?.addEventListener("click",()=>document.getElementById("addBtn")?.click());

  const bundle=document.getElementById("bundle"); if(!bundle) return;
  const addBtn=document.getElementById("addBtn"), buyNow=document.getElementById("buyNow"), extra=document.getElementById("bundleExtra");
  const products=(window.MY_PRODUCTS||[]), current=(window.MY_CURRENT||{});
  let qty=2, secondPick=(products.find(p=>p.handle!==current.handle)||products[0]||{}).handle;

  function others(){ return products; }
  function renderExtra(){
    if(!extra) return;
    if(qty===1){ extra.innerHTML=""; return; }
    if(qty===2){
      extra.innerHTML=`<div class="bpick__title">Choose your 2nd hat</div><div class="bpick__row">`+others().map(p=>`<button class="bpick__opt ${p.handle===secondPick?'sel':''}" type="button" data-h="${p.handle}"><img src="${p.img}" alt="${p.title}"><span>${p.title.replace(' Snapback','')}</span></button>`).join("")+`</div>`;
      extra.querySelectorAll(".bpick__opt").forEach(b=>b.addEventListener("click",()=>{ secondPick=b.dataset.h; extra.querySelectorAll(".bpick__opt").forEach(x=>x.classList.remove("sel")); b.classList.add("sel"); var pr=products.find(x=>x.handle===b.dataset.h); if(pr){ if(pr.imgs&&pr.imgs.length)setGallery(pr.imgs); var ht=document.querySelector(".pdp__info h1"); if(ht)ht.textContent=pr.title; var hd=document.querySelector(".pdp__desc"); if(hd&&pr.desc!=null)hd.innerHTML=pr.desc; } }));
    } else {
      extra.innerHTML=`<div class="bpick__title">Your set — one of each</div><div class="bpick__row">`+others().map(p=>`<div class="bpick__opt sel" style="cursor:default"><img src="${p.img}" alt="${p.title}"><span>${p.title.replace(' Snapback','')}</span></div>`).join("")+`</div>`;
    }
  }
  function selection(){
    if(qty===1) return [current.vid];
    if(qty===2){ const s=products.find(p=>p.handle===secondPick); return [current.vid, s?s.vid:current.vid]; }
    return products.slice(0,3).map(p=>p.vid);
  }
  bundle.addEventListener("click",e=>{ const o=e.target.closest(".bundle__opt"); if(!o)return; qty=+o.dataset.q; bundle.querySelectorAll(".bundle__opt").forEach(x=>x.classList.remove("sel")); o.classList.add("sel"); if(addBtn)addBtn.textContent=qty>1?`Add ${qty} to Cart`:"Add to Cart"; renderExtra(); });
  addBtn?.addEventListener("click",()=>{ const ids=selection().filter(Boolean); if(ids.length===1)Cart.add(ids[0],1); else Cart.addMany(ids); });
  buyNow?.addEventListener("click",async()=>{ const ids=selection().filter(Boolean); if(ids.length===1)await Cart.add(ids[0],1); else await Cart.addMany(ids); window.location.href="/checkout"; });
  renderExtra(); if(addBtn)addBtn.textContent=qty>1?`Add ${qty} to Cart`:"Add to Cart";
}

document.addEventListener("DOMContentLoaded",()=>{
  initLoader(); initHeader(); initActions(); initAccordions(); initReveal(); initPDP();
  if(window.Cart) Cart.refresh();
});
